import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  Grid,
  useTheme,
  View,
  CheckboxField,
  TextAreaField,
  Fieldset,
  SelectField,
  ScrollView,
  Alert,
  Autocomplete,
  Badge,
  BadgeVariations,
  Icon,
  Link,
  Image,
  Card,
  DropZone,
  Heading
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { formConfig, formatValue } from "./config";
import { MdCancel, MdMap, MdPictureAsPdf, MdStar, MdWhatsapp } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { generateContrattoBadante, getBadantiValues, getFileUrl, getRecensoreAPI, uploadFileAPI } from "../../data/api";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { BsMap } from "react-icons/bs";
const { v4: uuidv4 } = require('uuid');

const BadanteSchedaFields = (props) => {

  // get all recensori info
  const [recensori, setRecensori] = useState({});
  const getRecensoreLabel = (o) => o === undefined ? undefined : (o?.Nome + ' ' + o?.Cognome + ' (' + o?.Telefono +') - '+o?.Tipologia);
  const addRecensore = (recensore) => {
    recensore.label = getRecensoreLabel(recensore)
    setRecensori(prevRecensori => ({
      ...prevRecensori,
      [recensore.ID]: recensore
    }));
  }
  const getRecensore = async (id) => {
    try{
      const recensoreResponse = await getRecensoreAPI(id);
      addRecensore(recensoreResponse.recensore)
    } catch (e){
      console.log("Error retrieving info for recensore " +id+": "+e)
    }
  }
  useEffect(()=> {
    props.value['Recensioni'].map(r => r.ID_Recensore).forEach(r => {
      if(r !== null){
        getRecensore(r)
      }
    });
  }, [])
  
  // retrieve signed urls for saved images
  const [imagesUrl, setImagesUrl] = useState({});
  useEffect(() => {
    const fetchImageUrls = async () => {
      const newImagesUrl = {};
      const fetchFieldImageUrl = async (field, value, index?, outerField?) => {
        if (field.type === "UploadField" && field.dataType === 'image' && value) {
          const signedUrl = await getFileUrl(value);
          newImagesUrl[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] = signedUrl;
        } else if (field.type === "MultiField" && value?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            for (const subField of field.fields) {
              await fetchFieldImageUrl(subField, value[i][subField.name], i, field.name);
            }
          }
        }
      };
      for (const section of formConfig.sections) {
        for (const field of section.fields) {
          const value = props.value[field.name];
          await fetchFieldImageUrl(field, value);
        }
      }
      setImagesUrl(newImagesUrl);
    };
    fetchImageUrls();
  }, [props.value]);


  // handle upload file
  const [isUploading, setIsUploading] = useState({});
  const [isErrorUpload, setIsErrorUpload] = useState({});
  const uploadFile = async (field, file: File, index?, outerField?, fileName?) => {
    setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
    setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
    try{  
      const reader = new FileReader();
      reader.onload = async (event) => {
        try{
          const fileBody = {
            file_name: fileName !== undefined ? `${fileName}${file.name.slice(file.name.lastIndexOf('.'))}` : `${uuidv4()}${file.name.slice(file.name.lastIndexOf('.'))}`,
            file_content: (event.target.result as string).split(',')[1],
            category: field.documentCategory,
            document_type: field.documentType
          }
          const uploadResponse = await uploadFileAPI(fileBody);
          props.onChange({target: {name: field.name, value: uploadResponse.file_path}});
          setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
          setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
        } catch (e) {
          console.log('Upload of file failed ', e);
          setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
          setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
        }
      }
      reader.readAsDataURL(file);
    } catch (e) {
      console.log('Upload of file failed ', e);
      setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
      setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
    }
  };

  // handle generate contratto
  const [isGeneratingContratto, setIsGeneratingContratto] = useState(false);
  const [isErrorContratto, setIsErrorContratto] = useState(false);
  const generateContratto = async () => {
    setIsGeneratingContratto(true)
    setIsErrorContratto(false)
    try{  
      const response = await generateContrattoBadante(props.value.ID);
      props.onGenerateContratto(response.contratto_path, response.contratto_esteso_path);
      setIsGeneratingContratto(false)
      setIsErrorContratto(false)
    } catch (e) {
      console.log('Generate contratto failed ', e);
      setIsGeneratingContratto(false)
      setIsErrorContratto(true)
    }
  };

  // confirm generate button modal state
  const [isModalVisible, setIsModalVisible] = useState(false);

  const renderField = (field, nestedField, index?, outerField?, innerField?) => {
    const value = nestedField == true ? (props.value[outerField]?.[index]?.[innerField]) : props.value[field.name];
    if(field.hidden) return <React.Fragment key={field.name}></React.Fragment>;
        switch (field.type) {
      case "MultiField":
        return <React.Fragment key={field.name}>
          {props.value[field.name]?.length > 0 ? props.value[field.name]?.map((f, index) => {
            return <Card variation="elevated"   
            backgroundColor="var(--amplify-colors-background-secondary)"
            borderRadius="6px"  marginBottom="20px" columnSpan={[1,1,1,4]}>
            <Grid 
              templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
              gap="10px">
            {field?.fields?.map(o => 
              renderField({
                ...o, 
                name: (field.name+'.'+index+'.'+o.name)
              }, true, index, field.name, o.name))
            }
            </Grid>
          </Card>
          }) : "-"}
        </React.Fragment>
      case "RecensoreField":
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            <Text>{(value !== '' ? (recensori[value]?.label ?? value) : '-') ?? '-'}</Text>
          </View>
        );
      case "RatingField":
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            <Flex>
              {[...Array(5)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                  <label key={index}>
                    <input
                      type="radio"
                      name="rating"
                      value={ratingValue}
                      style={{ display: 'none' }}
                    />
                    <Icon
                      as={MdStar}
                      color={ratingValue <= (value) ? '#ffc107' : '#e4e5e9'}
                    />
                  </label>
                );
              })}
            </Flex>
          </View>
        );
        case "UploadField":
          return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            {
              (value == null) ?
              <Text key={value}>
                <i>Nessun file caricato</i>
              </Text>: 
              (
                field.dataType === "image" ?
                <Link onClick={() => window.open(imagesUrl[field.name], '_blank')}>
                  {
                    imagesUrl[field.name] ? 
                    <Image src={imagesUrl[field.name] ?? ''} alt={field.name ?? ''} maxWidth="300px" maxHeight="300px"/> :
                    <Loader></Loader>
                  }
                </Link> :
                <Link onClick={async () => {window.open(await getFileUrl(value), "_blank")}}>{"Visualizza file"}</Link>
              )
          }
          </View>
          );
          case "UploadContrattoField":
            return (
            <View columnSpan={field.columnSpan} key={field.name}>
              <Text><b>{field.label}</b></Text>
              {(value == null) ? 
                <DropZone
                  isDisabled={isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]}
                  acceptedFileTypes={field.acceptedFileTypes}
                  onDropComplete={({ acceptedFiles, rejectedFiles }) => {
                    uploadFile(field, acceptedFiles[0], index, outerField, `${props.value['ID']}_${(() => { const now = new Date(); return `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(2, '0')}${now.getFullYear()}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}` })()}`);
                  }}
                >
                  <Flex direction="column" alignItems="center">
                    <Text>Trascina il file qui o</Text>
                    <Button
                      size="small"
                      isDisabled={isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]}
                      onClick={() => {
                        const input = document.createElement('input');
                        input.type = 'file';
                        input.multiple = true;
                        input.accept = field.acceptedFileTypes.join(',');
                        input.style.display = 'none';
                        input.onchange = (event) => !(!(event.target as any).files || (event.target as any).files.length === 0) && uploadFile(field, (event.target as any).files[0], index, outerField, `${props.value['ID']}_${(() => { const now = new Date(); return `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(2, '0')}${now.getFullYear()}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}` })()}`);
                        document.body.appendChild(input);
                        input.click();
                        document.body.removeChild(input);
                      }}
                    >
                      Carica file
                    </Button>
                    {isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] && <Loader></Loader>}
                    {isErrorUpload[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] && <Text color="red">Errore nel caricamento del file!</Text>}
                  </Flex>
                </DropZone> : 
                <Flex>
                  <Text>
                    <Link onClick={async () => {window.open(await getFileUrl(value), "_blank")}}>
                      <Icon as={MdPictureAsPdf}></Icon>
                      {" Scarica file"}
                    </Link>
                    <Icon 
                      as={MdCancel} 
                      color="red" 
                      marginLeft="5px" 
                      marginBottom="2px" 
                      style={{cursor: "pointer"}}
                      onClick={() => props.onChange({target: {name: field.name, value: null}})}
                      >
                    </Icon>
                  </Text>
                </Flex>
            }
            </View>
            );
          case "ContrattoField":
              return (
                <View columnSpan={field.columnSpan} key={field.name}>
                  <Text><b>{field.label}</b></Text>
                    { !(value === null || value === '') ?
                    <Flex>
                      <Text>
                        <Link onClick={async () => {window.open(await getFileUrl(value), "_blank")}}>
                          <Icon as={MdPictureAsPdf}></Icon>
                          {" Scarica file"}
                        </Link>
                      </Text>
                    </Flex>
                    : '-'
                    }
                </View>
              );
      default:
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            <Text>{(value !== '' ? formatValue(value, field.name) : '-') ?? '-'} 
              {field.dataType === 'phone' && value !== null && value !== '' && <Icon 
                as={MdWhatsapp} 
                marginLeft={"5px"}
                marginBottom={"4px"}
                onClick={() => window.open('https://wa.me/'+value, '_blank')} 
                style={{"cursor":"pointer"}}>
              </Icon>}
              {field.dataType === 'address' && value !== null && value !== '' && <Icon 
                as={MdMap} 
                marginLeft={"5px"}
                marginBottom={"4px"}
                onClick={() => window.open(`${"https://www.google.com/maps/search/?api=1&query="}${encodeURIComponent(
                  field.getAddressString(props.value) ?? value
                )}`, '_blank')} 
                style={{"cursor":"pointer"}}>
              </Icon>}
            </Text>
          </View>
        );
    }
  };

  return (
    <>
      <Grid 
        templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
        gap="10px">
        {formConfig.sections.map((section, sectionIndex) => (
          <React.Fragment key={section.title}>
            <View columnSpan={[1, 1, 1, 4]}><h4>{section.title}</h4></View>
            {
              section.showContrattoButton &&
              <View columnSpan={[1, 1, 1, 4]}>
                <Button
                  width={"fit-content"}
                  size="small"
                  disabled={isGeneratingContratto}
                  onClick={() => setIsModalVisible(true)}
                >
                  {isGeneratingContratto ? <Loader></Loader> : "Genera nuova scheda OS"}
                </Button>
                {isErrorContratto && <Text color="red">Errore nella generazione della scheda!</Text>}
              </View> 
            }
            {section.fields.filter(f => f.isVisible !== undefined ? f.isVisible(props.value) : true).map(o => renderField(o, false))}
            <View columnSpan={[1, 1, 1, 4]}></View>
          </React.Fragment>
        ))}
      </Grid>
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Conferma generazione scheda OS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text>Sei sicuro di voler generare una nuova scheda OS?</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variation="primary" onClick={async () => {setIsModalVisible(false); await generateContratto();}}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BadanteSchedaFields;